import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./Events.css";

const api_url = process.env.REACT_APP_API_URL;

const Events = () => {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const eventsPerPage = 6;

    // Fetch all events from API (no pagination)
    const fetchEvents = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${api_url}/events/events.php`);
            setEvents(response.data.events || response.data); // support both structures
        } catch (error) {
            console.error("Error fetching events:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    // Calculate pagination
    const totalPages = Math.ceil(events.length / eventsPerPage);
    const startIndex = (page - 1) * eventsPerPage;
    const currentEvents = events.slice(startIndex, startIndex + eventsPerPage);

    // Change page
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <>
            {/* <!-- Header Start --> */}
            <div className="container-fluid bg-primary py-5 mb-5 page-header">
                <div className="container py-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 text-center">
                            <h1 className="display-3 text-white animated slideInDown">Events</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb justify-content-center">
                                    <li className="breadcrumb-item"><Link className="text-white" to="/">Home</Link></li>
                                    <li className="breadcrumb-item text-white active" aria-current="page">Events</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Header End --> */}

            {/* <!--====== EVENTS PART START ======--> */}
            <section id="event-page" className="pt-90 pb-120 gray-bg">
                <div className="container">
                    {loading ? (
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="row">
                                {currentEvents.length > 0 ? (
                                    currentEvents.map((event) => (
                                        <div className="col-lg-6" key={event.id}>
                                            <div className="singel-event-list mt-30">
                                                <div className="event-thum">
                                                    <img
                                                        src={event.image}
                                                        alt={event.title}
                                                        style={{
                                                            width: "50%",
                                                            height: "auto",
                                                            objectFit: "cover",
                                                        }}
                                                    />
                                                </div>
                                                <div className="event-cont">
                                                    <span>
                                                        <i className="fa fa-calendar"></i>{" "}
                                                        {new Date(event.event_date).toLocaleDateString("en-GB", {
                                                            day: "numeric",
                                                            month: "long",
                                                            year: "numeric",
                                                        })}
                                                    </span>
                                                    <Link to={`/event_details/${event.slug_url}`}>
                                                        <h4>{event.title}</h4>
                                                    </Link>
                                                    <span>
                                                        <i className="fa fa-clock-o"></i>{" "}
                                                        {event.start_time} - {event.end_time}
                                                    </span>
                                                    <span>
                                                        <i className="fa fa-map-marker"></i>{" "}
                                                        {event.location}
                                                    </span>
                                                    <p>{event.short_message}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center text-muted py-5">
                                        No events found.
                                    </div>
                                )}
                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="row">
                                    <div className="col-lg-12">
                                        <nav className="event-pagination mt-50">
                                            <ul className="pagination justify-content-center">
                                                <li className={`page-item ${page <= 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page - 1)}
                                                    >
                                                        <i className="fa fa-angle-left"></i>
                                                    </button>
                                                </li>

                                                {[...Array(totalPages)].map((_, i) => (
                                                    <li
                                                        key={i}
                                                        className={`page-item ${page === i + 1 ? "active" : ""}`}
                                                    >
                                                        <button
                                                            className="page-link"
                                                            onClick={() => handlePageChange(i + 1)}
                                                        >
                                                            {i + 1}
                                                        </button>
                                                    </li>
                                                ))}

                                                <li className={`page-item ${page >= totalPages ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => handlePageChange(page + 1)}
                                                    >
                                                        <i className="fa fa-angle-right"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </section>
            {/* <!--====== EVENTS PART ENDS ======--> */}
        </>
    );
};

export default Events;
